/* <blog-besties> - dot indicators for the mobile besties scroll-snap rail.
 *
 * Observed attributes: none.
 * Dispatched events:   none.
 * Consumed events:     none.
 *
 * The rail is a native horizontal scroller, so it works with JS off; this
 * element only adds the active-dot readout and click-to-scroll. The dots are
 * rendered [hidden] by Liquid and revealed here, so no dead controls appear
 * when the element never upgrades.
 */

class BlogBesties extends HTMLElement {
  connectedCallback() {
    this.rail = this.querySelector('[data-besties-rail]');
    this.dotWrap = this.querySelector('[data-besties-dots]');
    if (!this.rail || !this.dotWrap) return;

    this.items = Array.from(this.querySelectorAll('[data-bestie-item]'));
    this.dots = Array.from(this.dotWrap.querySelectorAll('[data-besties-dot]'));
    if (this.items.length < 2 || !this.dots.length) return;

    this.dotWrap.hidden = false;

    this._onDotClick = this._onDotClick.bind(this);
    this.dotWrap.addEventListener('click', this._onDotClick);

    // IntersectionObserver against the rail itself is the sanctioned way to
    // track which card is in view (CLAUDE.md Section 4) - no scroll polling.
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this._setActive(this.items.indexOf(entry.target));
        });
      },
      { root: this.rail, threshold: 0.6 }
    );
    this.items.forEach((item) => this.observer.observe(item));
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.dotWrap) this.dotWrap.removeEventListener('click', this._onDotClick);
  }

  _onDotClick(event) {
    const dot = event.target.closest('[data-besties-dot]');
    if (!dot) return;
    const index = Number(dot.dataset.bestiesDot);
    const target = this.items[index];
    if (!target) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.rail.scrollTo({
      left: target.offsetLeft - this.rail.offsetLeft,
      behavior: reduced ? 'auto' : 'smooth',
    });
  }

  _setActive(index) {
    if (index < 0) return;
    this.dots.forEach((dot, i) => {
      const active = i === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }
}

if (!customElements.get('blog-besties')) {
  customElements.define('blog-besties', BlogBesties);
}
